export function getCspNonce() {
  return document.head.querySelector('meta[name="csp-nonce"]')?.getAttribute("content");
}

export function getCsrfToken() {
  return document.head.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
}

function setCspNonce(element: HTMLElement) {
  const nonce = getCspNonce();
  if (nonce) {
    element.setAttribute("nonce", nonce);
  }
}

// patch for vendor libs and app code
export function patchDocumentHeadAppendChildWithCspStyleNonce(): void {
  const patchFlag = "patched-with-scp-nonce";
  if (document.head[patchFlag]) return;
  document.head[patchFlag] = true;

  const originalAppendChild = document.head.appendChild;
  document.head.appendChild = function <T extends Node>(node: T): T {
    if (node instanceof HTMLStyleElement) {
      setCspNonce(node);
    }
    return originalAppendChild.call(this, node);
  };

  const originalInsertBefore = document.head.insertBefore;
  document.head.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
    if (newNode instanceof HTMLStyleElement) {
      setCspNonce(newNode);
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
}

export function redirectToAllowedUrl(allowedDomains: string[], url: string) {
  try {
    const urlObj = new URL(url);
    if (allowedDomains.includes(urlObj.hostname)) {
      window.location.replace(urlObj.toString());
    } else {
      console.error("Blocked unsafe redirect:", urlObj.toString());
    }
  } catch (e) {
    console.error("Malformed redirect:", url);
  }
}
